export default __webpack_public_path__ + "static/media/ceramic-bead-blasting-icon.013401dc.svg";